import { render, staticRenderFns } from "./BooleanFacet.vue?vue&type=template&id=4871bc5c&"
import script from "./BooleanFacet.vue?vue&type=script&lang=js&"
export * from "./BooleanFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports